import account from './account'
import fee from './fee'
import contract from './contract'
import template from './template'
import approval from './approval'
import notice from './notice'
import sign from './sign'
import company from './company'
import help from './help'
import trial from './trial'

/**
 * 路由 meta 源信息说明
 * layout： 布局，通用的布局可在 @/layout/Index.vue 中扩展
 *   user 用户业务的默认布局（默认）
 *   admin 管理员控制台布局
 *   empty 空白布局
 *
 *  配置方式：
 *  1. 只指定布局
 *     meta: {
 *       layout: 'admin'
 *     }
 *
 *  2. 指定额外布局选项，需要该布局组件提供 props 选项
 *     meta: {
 *       title: '页面标题'
 *       layout: {
 *         name: 'user', // 布局名称
 *         subPage: true // 其他布局选项
 *     }
 */

/* 用户页面路由 */
export default {
  path: '/user',
  name: 'UserCenter',
  component: () => import('@/layout/Empty.vue'),
  children: [account, fee, contract, template, approval, notice, sign, company, ...help, trial]
}
